export default "__VITE_ASSET__cd988439__"